import { useState } from "react";
import { delay } from "../../utils";
import "./style.css";

function CustomButton({ isPrimary = true, children, onClick = () => { }, className = "", id = "", style = {}, disabled = false, size = "medium", ...rest }) {
    return (
        <button
            id={id}
            style={style}
            // className={(isPrimary ? "primary-button " : "secondary-button ") + className + (disabled ? "" : " act")}
            className={(isPrimary ? "primary-button " : "secondary-button ") + className + " " + ("cb-size-" + size) + (" cb-disabled-" + disabled)}
            onClick={(e) => {
                e.preventDefault();
                delay(() => {
                    onClick(e);
                }, 200)
            }}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
}

export default CustomButton;